// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AssetSelect — custom logo dropdown. Plain classes, theme-token driven so it
   works on dashboard pages and the customer-facing checkout alike. */

.asset-select {
  position: relative;
  width: 100%;
}

.asset-select__control {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 46px;
  padding: 8px 12px;
  background: var(--bg-primary, #fff);
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: var(--radius-md, 10px);
  color: var(--text-primary, #1e293b);
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, box-shadow 0.15s;
  font-family: var(--iv-sans);
}

.asset-select__control:hover:not(:disabled) {
  border-color: var(--text-muted, #94a3b8);
}

.asset-select.is-open .asset-select__control {
  border-color: var(--accent-primary, #8b5cf6);
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.12);
}

.asset-select.is-disabled .asset-select__control {
  opacity: 0.6;
  cursor: not-allowed;
}

.asset-select__value {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

.asset-select__placeholder {
  flex: 1 1;
  color: var(--text-muted, #94a3b8);
}

.asset-select__labels {
  display: flex;
  flex-direction: column;
  gap: 1px;
  line-height: 1.2;
  min-width: 0;
}

.asset-select__label {
  font-weight: 600;
  color: var(--text-primary, #1e293b);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.asset-select__sub {
  font-size: 12px;
  color: var(--text-muted, #94a3b8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.asset-select__chevron {
  flex-shrink: 0;
  color: var(--text-muted, #94a3b8);
  transition: transform 0.2s;
}
.asset-select__chevron.is-open {
  transform: rotate(180deg);
}

.asset-select__menu {
  position: absolute;
  z-index: 50;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 6px;
  list-style: none;
  max-height: 280px;
  overflow-y: auto;
  background: var(--bg-primary, #fff);
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: var(--radius-md, 10px);
  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgba(0, 0, 0, 0.1));
}

.asset-select__opt {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.asset-select__opt:hover {
  background: var(--bg-secondary, #f8fafc);
}

.asset-select__opt.is-active {
  background: var(--bg-secondary, #f8fafc);
}

.asset-select__check {
  margin-left: auto;
  color: var(--accent-primary, #8b5cf6);
  flex-shrink: 0;
}

.asset-select__empty {
  padding: 14px 10px;
  text-align: center;
  font-size: 13px;
  color: var(--text-muted, #94a3b8);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/AssetSelect.css"],"names":[],"mappings":"AAAA;qEACqE;;AAErE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,8CAA8C;EAC9C,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,8CAA8C;EAC9C,qCAAqC;EACrC,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC","sourcesContent":["/* AssetSelect — custom logo dropdown. Plain classes, theme-token driven so it\n   works on dashboard pages and the customer-facing checkout alike. */\n\n.asset-select {\n  position: relative;\n  width: 100%;\n}\n\n.asset-select__control {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 46px;\n  padding: 8px 12px;\n  background: var(--bg-primary, #fff);\n  border: 1px solid var(--border-color, #e2e8f0);\n  border-radius: var(--radius-md, 10px);\n  color: var(--text-primary, #1e293b);\n  font-size: 14px;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  font-family: var(--iv-sans);\n}\n\n.asset-select__control:hover:not(:disabled) {\n  border-color: var(--text-muted, #94a3b8);\n}\n\n.asset-select.is-open .asset-select__control {\n  border-color: var(--accent-primary, #8b5cf6);\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.12);\n}\n\n.asset-select.is-disabled .asset-select__control {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.asset-select__value {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n.asset-select__placeholder {\n  flex: 1;\n  color: var(--text-muted, #94a3b8);\n}\n\n.asset-select__labels {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  line-height: 1.2;\n  min-width: 0;\n}\n\n.asset-select__label {\n  font-weight: 600;\n  color: var(--text-primary, #1e293b);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.asset-select__sub {\n  font-size: 12px;\n  color: var(--text-muted, #94a3b8);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.asset-select__chevron {\n  flex-shrink: 0;\n  color: var(--text-muted, #94a3b8);\n  transition: transform 0.2s;\n}\n.asset-select__chevron.is-open {\n  transform: rotate(180deg);\n}\n\n.asset-select__menu {\n  position: absolute;\n  z-index: 50;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n  max-height: 280px;\n  overflow-y: auto;\n  background: var(--bg-primary, #fff);\n  border: 1px solid var(--border-color, #e2e8f0);\n  border-radius: var(--radius-md, 10px);\n  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgba(0, 0, 0, 0.1));\n}\n\n.asset-select__opt {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.asset-select__opt:hover {\n  background: var(--bg-secondary, #f8fafc);\n}\n\n.asset-select__opt.is-active {\n  background: var(--bg-secondary, #f8fafc);\n}\n\n.asset-select__check {\n  margin-left: auto;\n  color: var(--accent-primary, #8b5cf6);\n  flex-shrink: 0;\n}\n\n.asset-select__empty {\n  padding: 14px 10px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--text-muted, #94a3b8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
